import React, { useEffect, useState } from "react";
import { Alert, Box, Button, CircularProgress } from "@mui/material";
import { loadScreen, canonicalScreen } from "../utils/screenRegistry";
import "./BelezaUI/styles.css";

// The salon scope lives in the dynamic screen host, not in per-screen one-off
// inline styles. Pages for other industries retain their existing UI.
const salonScreens = new Set([
  "BelezaFinanceiro360", "BelezaFinanceiroClassificacoes", "BelezaFinanceiroCentrosCusto", "BelezaFinanceiroContas", "BelezaFinanceiroMovimentacoes", "BelezaRelatorios", "ComercialComissoesOperacionais", "BelezaPoliticas360",
  "BelezaWhatsAppMeta", "Entidades", "Perfis", "Unidades", "BelezaCadastros", "BelezaClientes",
  "BelezaEspacos", "BelezaPacotes", "BelezaProdutos", "BelezaPromocoes", "BelezaServicos",
  "BelezaAgenda", "ComercialPdvSalao", "ComercialRecepcaoSalao", "Permissao", "Usuarios",
  "BelezaComandas360", "BelezaEstoque360", "BelezaExpedicao", "BelezaFornecedores", "BelezaContasPagar", "BelezaContasReceber", "BelezaFinanceiroOperacoes", "BelezaInventarios", "BelezaPdvConfiguracoes", "ComercialColaborador", "ComercialMinhaDisponibilidade",
  "ClassesFiscais", "FiscalVarejo", "NcmVarejo",
]);

export default function DynamicComponentLoader({ component, ...props }) {
  const [loaded, setLoaded] = useState(null);
  const [error, setError] = useState(false);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let active = true;
    setLoaded(null); setError(false);
    loadScreen(component).then(module => {
      if (!module.default) throw new Error("Componente sem exportação padrão.");
      if (active) setLoaded({ name: component, Component: module.default });
    }).catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [component, retry]);
  if (error) return <Alert severity="error" sx={{ m: 3 }} action={<Button onClick={() => setRetry(v => v + 1)}>Tentar novamente</Button>}>Não foi possível abrir a tela {component}. Atualize a página se uma nova versão acabou de ser instalada.</Alert>;
  if (!loaded || loaded.name !== component) return <Box role="status" aria-label="Carregando tela" sx={{ p: 5, textAlign: "center" }}><CircularProgress /></Box>;
  const screen = canonicalScreen(component);
  const view = <loaded.Component {...props} />;
  return salonScreens.has(screen)
    ? <Box className="salao-standard-context" sx={{ width: '100%', minWidth: 0 }}>{view}</Box>
    : view;
}
